const messages = {
    en: {
        MainFooter: {
            "Navigation": "Navigation",
            "About Us": "About Us",
            "Contact Us": "Contact Us",
            "TermsConditions": "Terms & Conditions",
            "Information": "Information",
            "Login": "Login",
            "Email Address": "Email Address",
            "Mobile Number": "Mobile Number",
            "Password": "Password",
            "Remember Me": "Remember Me",
            "Forgot Password": "Forgot Password",
            "Dont have an account": "Don't have an account",
            "Register Free": "Register Free",
            "Enter you Email Id": "Enter you Email Id",
            "Submit": "Submit",
            "Reset Password": "Reset Password",
            "Old Password": "Old Password",
            "New Password": "New Password",
            "Confirm Password": "Confirm Password",
            "Free Registration": "Free Registration",
            "First Name": "First Name",
            "Middle Name": "Middle Name",
            "Last Name": "Last Name",
            "Gender": "Gender",
            "Male": "Male",
            "Female": "Female",
            "Date of Birth": "Date of Birth",
            "Maritial Status": "Maritial Status",
            "Select": "Select",
            "Married": "Married",
            "Unmarried": "Unmarried",
            "Education": "Education",
            "Education Group": "Education Group",
            "Income per year": "Income per year",
            "Working Place": "Working Place",
            "Family Residence": "Family Residence",
            "Native Place": "Native Place",
            "Email": "Email",
            "Create Password": "Create Password",
            "Register": "Register",
            "By clicking on Register you acctept our": "By clicking on 'Register' you acctept our",
            "terms and conditions": "terms and conditions",
            "Already have an account": "Already have an account",
            "OTP Confirmation": "OTP Confirmation",
            "Please enter the verification code sent to your": "Please enter the verification code sent to your",
            "registered mobile number": "registered mobile number",
            "Resend OTP": "Resend OTP",
            "Success": "Success",
            "You hava successful": "You hava successful",
        },
        share: {
            "Share": "Share Profile",
            "Copy_Link": "Copy Profile Link",
            "Facebook": "Facebook",
            "Whatsapp": "Whatsapp",
            "Instagram": "Instagram",
            "Successfully copy to clipboard": "Successfully copy to clipboard",
        },
        Home: {
            "WELCOME_TO_nimbalkar_maratha_vadhu_var_suchak": "WELCOME TO nimbalkar maratha vadhu var suchak",
            "get_started": "get started",
            "WHO_WE_ARE": "WHO WE ARE",
            "most_trusted_exclusive_matrimony": "Most trusted & exclusive Matrimony",
            "experience": "Experience",
            "marriages_are_settled": "marriages are settled",
            "how_we_work": "How We Work",
            "features": "Features",
            "get_hand_picked_match_profile": "get hand picked match profile",
            "search_shortlist_by_your_choice": "search & shortlist by your choice",
            "send_receive": "send / receive",
            "interest": "interest",
            "view_contact_to_call_or_message_directly": "view contact to call or message directly",
            "meet_your_dream_partner": "meet your dream partner at our office",
        },
        OuterHeader: {
            "Home": "Home",
            "our procedure": "our procedure",
            "success stories": "success stories",
            "Login": "Login",
            "Register free": "Register free",
        },
        SubFooter: {
            "Thousands": "Thousands",
            "of Happy Marriages": "of Happy Marriages",
            "register free": "register free",
            "This website only meant for users with a banafide intent to enter in to matrimonial alliance &amp; is not meant for users intrested in dating only and this website should not be used to post an obscene": "This website only meant for users with a banafide intent to enter in to matrimonial alliance &amp; is not meant for users intrested in dating only and this website should not be used to post an obscene",
            "View Membership": "View Membership",
        }
    },
    mr: {
        MainFooter: {
            "Login": "लॉगिन",
        },
    },
};
export default messages;